import {Grid, Typography} from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";
import React from "react";
import {makeStyles} from "@material-ui/core/styles";

/**
 * the function the use styles with JSS.
 * @type {(props?: any) => ClassNameMap<"address"|"title">}
 */
const useStyles = makeStyles((theme) => ({
    address: {
        fontWeight: 500,
        color: theme.palette.primary.main,

    },
}))
/**
 * This component represents every single item of shipping details. Addresses and time.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const Item = props => {
    const classes = useStyles();
    return(
        <Grid item xs={12}>
            <Typography>{props.title}:</Typography>
            {props.text ?
                <Typography className={classes.address}>{props.text}</Typography>
                : <Skeleton height={30}/>
            }
        </Grid>
    );
};
export default Item;